import React from 'react';

import { RCThemeContext, RCThemeContextProps } from '../';

/**
 * A hook for accessing the current site theme.
 *
 * Use the `darkMode` boolean if you need to pivot based on the current color mode.
 */
export function useTheme(): RCThemeContextProps {
  return React.useContext(RCThemeContext);
}
